import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HardCodedValues {
    public defaultProfileImg = 'assets/images/avatars/profile.jpg';

    public project = 'Project'
    public addons = 'Sub-Project'
    public client = 'Client'
    public profileView = 'Profile-View'
    public sprint = 'Sprint'
    public task = 'Task'
    public opportunity = 'Opportunity'

    getValues(value) {
        switch (value) {

            //Clients
            case 'firstName':
                return 'First Name';
            case 'lastName':
                return 'Last Name';
            case 'companyName':
                return 'Company Name';
            case 'companyAddress':
                return 'Company Address';
            case 'companyPhoneNo':
                return 'Company Phone No';
            case 'currency':
                return 'Currency';
            case 'preferredContactTime':
                return 'Preferred Contact Time';
            case 'pickTime':
                return 'Pick Time';
            case 'websiteURL':
                return 'Website URL';
            case 'facebookURL':
                return 'Facebook URL';
            case 'twitterURL':
                return 'Twitter URL';
            case 'skypeURL':
                return 'Skype URL';

            //Projects
            case 'projectName':
                return 'Project Name';
            case 'projectType':
                return 'Billing Type';
            case 'currentStatus':
                return 'Current Status';
            case 'projectStartDate':
                return 'Project Start Date';
            case 'reason':
                return 'Reason';
            case 'actualCompletionDate':
                return 'Actual Completion Date';
            case 'extendedCompletionDate':
                return 'Extended Completion Date';
            case 'projectDescription':
                return 'Project Description';

            //Profile
            case 'systemId':
                return 'System ID';
            case 'deviceName':
                return 'Device Name';
            case 'virusScan':
                return 'Virus Scan';
            case 'systemType':
                return 'System Type';
            case 'biggbossStatus':
                return 'Big boss Status';
            case 'operatingSystem':
                return 'Operating System';
            case 'resignationAppliedDate':
                return 'Resignation Applied Date';
            case 'noticePeriod':
                return 'Notice Period';
            case 'resignationAcceptedDate':
                return 'Resignation Accepted Date';
            case 'releasedDate':
                return 'Released Date';

            case 'startdate1':
                return 'Start Date';
            case 'enddate1':
                return 'End Date';
            case 'popupStatus':
                return 'Resource Status';
            case 'popupRole':
                return 'Resource Role';
            case 'popupResourcesType':
                return 'Resource Type';
            case 'screenShotSyncTime':
                return 'Screenshot Sync Time';

            // Sprint
            case 'startDate':
                return 'Start Date';
            case 'endDate':
                return 'End Date';
            case 'sprintGoal':
                return 'Sprint Goal';

            // Opportunity
            case 'submittedDate':
                return 'Submitted Date';
            case 'requestedDate':
                return 'Requested Date';
            case 'requestedDate':
                return 'Requested Date';

            case 'enquiryName':
                return 'Opportunity Name';
            case 'status':
                return 'status';
            case 'referenceUrl':
                return 'reference url';
            case 'designUrl':
                return 'design url';
            case 'opportunityType':
                return 'opportunity type';
            case 'opportunitySize':
                return 'opportunity size';
            case 'opportunityPercentage':
                return 'opportunity percentage';

            case 'estimateTemplate':
                return 'estimate template';
            case 'domain':
                return 'domain';
            case 'technologies':
                return 'technology';
            case 'assignees':
                return 'assignee';

            case 'isLogin':
                return 'Login';
            case 'isLogout':
                return 'Logout';
            case 'isProjectSwitched':
                return 'Project Switched';
        }
    }

}
